import { createSlice } from "@reduxjs/toolkit";
import { getFiltersKey, getQueryFilters } from "lib/utils";

const initialFilters = {};
export const initialFiltersKey = getFiltersKey(initialFilters);

const filtersSlice = createSlice({
  name: "filters",
  initialState: {
    filters: initialFilters,
    summaryFilters: initialFilters,
    filtersKey: initialFiltersKey,
    groupBy: {
      key: "",
      label: "By Product-Retailer-Area",
    },
  },
  reducers: {
    setFilters: (state, action) => {
      const filters = {
        ...state.filters,
        ...action.payload,
      };

      return {
        ...state,
        filters,
        filtersKey: getFiltersKey(filters),
        queryFilters: getQueryFilters(filters),
      };
    },
    setCleanFilters: (state) => {
      return {
        ...state,
        filters: {},
        filtersKey: getFiltersKey({}),
        queryFilters: {},
      };
    },
    setSummaryFilters: (state, action) => {
      const summaryFilters = {
        ...state.summaryFilters,
        ...action.payload,
      };

      return {
        ...state,
        summaryFilters,
      };
    },
    setCleanSummaryFilters: (state) => {
      return {
        ...state,
        summaryFilters: {},
      };
    },
    setGroupBy: (state, action) => {
      return { ...state, groupBy: action.payload };
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = filtersSlice;

// Extract and export each action creator by name
export const {
  setFilters,
  setCleanFilters,
  setGroupBy,
  removeFilters,
  setSummaryFilters,
  setCleanSummaryFilters,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
